import React, { useEffect, useRef, createElement, Fragment } from 'react';
import algoliasearch from 'algoliasearch/lite';
import {
  InstantSearch,
  Hits,
  Highlight,
  Pagination,
  SearchBox,
  SortBy,
  Snippet,
  Stats,
  RefinementList
} from 'react-instantsearch';
import { history } from 'instantsearch.js/es/lib/routers';
import { simple } from 'instantsearch.js/es/lib/stateMappings';
import {
  scrollToElement,
  getQueryParamsAsObject,
  decodeHtml
} from '../../lib/utilities';
import $ from 'jquery';

import '@algolia/autocomplete-theme-classic';

const appId = wlAlgolia.application_id;
const apiKey = wlAlgolia.search_api_key;
const indexName = wlAlgolia.indices.searchable_posts.name;
const searchClient = algoliasearch(appId, apiKey);
const algoliaIndex = {
  main: indexName,
  newest: `${indexName}_newest`,
  oldest: `${indexName}_oldest`,
  popular: `${indexName}_popular`
};

const routing = {
  router: history(),
  stateMapping: {
    stateToRoute(uiState) {
      const indexUiState = uiState[indexName];
      const post_type_label = indexUiState.refinementList
        ? indexUiState.refinementList.post_type_label
        : null;
      const cooking_methods = indexUiState.refinementList
        ? indexUiState.refinementList.cooking_methods
        : null;

      let returnObj = {
        s: indexUiState.query,
        sortBy: indexUiState.sortBy,
        page: indexUiState.page
      };

      if (post_type_label) returnObj['post_type_label'] = post_type_label;
      if (cooking_methods) returnObj['cooking_methods'] = cooking_methods;

      return returnObj;
    },
    routeToState(routeState) {
      let post_type_label = routeState.post_type_label
        ? routeState.post_type_label
        : [];
      let cooking_methods = routeState.cooking_methods
        ? routeState.cooking_methods
        : [];

      return {
        [indexName]: {
          query: routeState.s,
          refinementList: {
            post_type_label: post_type_label,
            cooking_methods: cooking_methods
          },
          sortBy: routeState.sortBy,
          page: routeState.page
        }
      };
    }
  }
};

function Hit({ hit }) {
  hit.__cardFooter = '';
  if (hit.total_time) {
    hit.__cardFooter =
      hit.__cardFooter + '<i class="icon-clock-time"></i>' + hit.total_time;
  }
  hit._highlightedCategory =
    hit.singular_post_type === 'Post' ? 'Story' : hit.singular_post_type;
  hit._highlightedCategory =
    hit._highlightedCategory +
    ' &bull; ' +
    (hit.taxonomy ? decodeHtml(hit.taxonomy) : 'beeflovingtexans.com');
  hit._highlightedCategory = decodeHtml(hit._highlightedCategory);

  return (
    <>
      {(hit.post_type === 'beef-tv' && hit.taxonomy !== 'BBQuest' && (
        <article className="card card--widescreen">
          <div
            className="search-hit module-hover-root card__link"
            data-object-id={hit.objectID}
            data-object-position={hit.__position}
          >
            <section
              data-modal-show={hit.video_id}
              data-video={hit.video_id}
              className="card__header"
              onClick={(event) => {
                let $resource = $(event.currentTarget);
                let videoId = $resource.data('video');
                if (videoId) {
                  // Replace Iframe with new video
                  let iframeHTML =
                    `<iframe
                                id="toolkit-player"
                                width="100%"
                                height="100%"
                                src="https://www.youtube.com/embed/` +
                    videoId +
                    `?feature=oembed&enablejsapi=1"
                                title="YouTube video player"
                                frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen>
                            </iframe>`;

                  $('.u--embed-responsive').html(iframeHTML);
                  $('#beef-tv-search-modal-btn').trigger('click');
                }
              }}
            >
              <div className="card__media">
                <img src={hit.post_image} alt={hit.post_title} />
              </div>
            </section>

            <section className="card__body">
              <p className="card__taxonomy">{hit._highlightedCategory}</p>
              <h4 className="card__title">
                <Highlight
                  attribute="post_title"
                  hit={hit}
                  highlightedTagName="em"
                />
              </h4>
            </section>
          </div>
        </article>
      )) || (
        <article className="card card--recipe">
          <a
            href={hit.permalink}
            title={hit.permalink}
            className="search-hit module-hover-root card__link"
            data-object-id={hit.objectID}
            data-object-position={hit.__position}
          >
            <section className="card__header">
              <div className="card__media">
                <img src={hit.post_image} alt={hit.post_title} />
              </div>
            </section>

            <section className="card__body">
              <p className="card__taxonomy">{hit._highlightedCategory}</p>
              <h4 className="card__title">
                <Highlight
                  attribute="post_title"
                  hit={hit}
                  highlightedTagName="em"
                />
              </h4>
              <section className="card__footer">
                <div className="grid grid--card grid--reverse grid--middle">
                  <div className="grid__col-xs-12 grid__col-md-6 u--margin-top-10-max-sm u--margin-bottom-0"></div>
                  <div className="grid__col-xs-12 grid__col-md-6">
                    {hit.total_time && (
                      <div className="card__time">
                        <i className="icon-clock-time"></i>
                        {hit.total_time}
                      </div>
                    )}
                  </div>
                </div>
              </section>
            </section>
          </a>
        </article>
      )}
    </>
  );
}

const transformMenuItems = (items) => {
  return items.map((item) => {
    item.count = '';
    return item;
  });
};

const queryHook = (query, search) => {
  search(query);
};

export default function SiteSearch() {
  return (
    <InstantSearch
      indexName={indexName}
      searchClient={searchClient}
      insights={true}
      routing={routing}
      future={{
        preserveSharedStateOnUnmount: true
      }}
    >
      <section className="section">
        <div className="container">
          <div className="grid grid--bottom grid--no-gutter-edges u--margin-bottom-10">
            <div className="grid__col-xs-12 grid__col-sm-6 grid__col-md-8 u--margin-bottom-0">
              <h1 className="page-title u--margin-bottom-0">Search</h1>
              {
                <div className="aa-InputWrapper form__field u--margin-bottom-0">
                  <SearchBox
                    placeholder="Search by Keyword..."
                    queryHook={queryHook}
                    searchAsYouType={true}
                    classNames={{
                      root: 'js-search-box',
                      submit: 'u--display-none'
                    }}
                  />
                </div>
              }
            </div>
            <div className="grid__col-xs-6 grid__col-sm-3 grid__col-md-2 u--margin-bottom-0">
              <div id="select-dropdown-categories" className="select-dropdown">
                <div className="select-dropdown__header">
                  <div className="select-dropdown__header-label">
                    <div>Categories</div>
                  </div>
                  <i className="icon-caret-dropdown"></i>
                </div>
                <RefinementList
                  attribute="post_type_label"
                  transformItems={transformMenuItems}
                  sortBy={['name:asc']}
                  classNames={{
                    root: 'algolia-refinement-list',
                    list: 'select-dropdown__list',
                    item: 'select-dropdown__item',
                    label: 'select-dropdown__checkbox-container',
                    checkbox: 'select-dropdown__checkbox',
                    count: 'select-dropdown__count'
                  }}
                />
              </div>
            </div>
            <div className="grid__col-xs-6 grid__col-sm-3 grid__col-md-2 u--margin-bottom-0">
              <div
                id="select-dropdown-cooking-method"
                className="select-dropdown"
              >
                <div className="select-dropdown__header">
                  <div className="select-dropdown__header-label">
                    <div>Cooking Methods</div>
                  </div>
                  <i className="icon-caret-dropdown"></i>
                </div>
                <RefinementList
                  attribute="cooking_methods"
                  transformItems={transformMenuItems}
                  sortBy={['name:asc']}
                  classNames={{
                    root: 'algolia-refinement-list',
                    list: 'select-dropdown__list',
                    item: 'select-dropdown__item',
                    label: 'select-dropdown__checkbox-container',
                    checkbox: 'select-dropdown__checkbox',
                    count: 'select-dropdown__count'
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container site-search-algolia-container u--margin-top-20">
          <div className="divider divider--top">
            <div
              id="algolia-categories"
              className="grid grid--between grid--bottom grid--no-gutter site-search-results-count-sort-container"
            >
              <h3 className="u--margin-0">Search Results</h3>
              <div className="algolia-sortby-container">
                <Stats
                  classNames={{
                    root: 'u--margin-right-10'
                  }}
                  translations={{
                    rootElementText({ hitsPerPage, nbHits, nbPages, page }) {
                      return `${nbHits} Results`;
                    }
                  }}
                />
                <SortBy
                  items={[
                    { value: indexName, label: 'Relevance' },
                    { value: `${indexName}_popular`, label: 'Popular' },
                    { value: `${indexName}_newest`, label: 'Newest' },
                    { value: `${indexName}_oldest`, label: 'Oldest' }
                  ]}
                />
              </div>
            </div>
            <hr className="u--display-none-md-max"></hr>
          </div>
          <Hits hitComponent={Hit} classNames={{ list: 'container' }} />
          <Pagination showFirst={false} showLast={false} />
        </div>
      </section>
    </InstantSearch>
  );
}
